// Hungarian dictionary — keep structurally identical to en.js.
const hu = {
  nav: {
    info: 'INFO',
  },

  hero: {
    subtitle: 'Élje át a tollaslabda tornákat a gyönyörű Trencsén városában',
    info: 'INFO',
    book: 'SZÁLLÁSFOGLALÁS',
  },

  home: {
    upcomingTitle: 'Közelgő események 2026-ban',
    u15Card: 'SLOVAK YOUTH Badminton Europe U15 circuit',
    u17Card: 'SLOVAK YOUTH Badminton Europe U17 circuit',
    u13Card: 'SLOVAK YOUTH Badminton Europe U13 circuit',
    labelUpcoming: 'Hamarosan',
    eventDateShort: 'szeptember 25–27.',
  },

  tournament: {
    entryDeadline: 'Nevezési határidő:',
    upcoming: 'Hamarosan',
    deadlineU17: '2026. augusztus 25.',
    deadlineU13: '2026. szeptember 11.',
    eventDate: '2026. szeptember 25–27.',
    invitation: 'MEGHÍVÓ',
    register: 'NEVEZÉS',
    draws: 'SORSOLÁS',
    acceptanceList: 'RÉSZTVEVŐK LISTÁJA',
    infoTitle: 'Torna információk',
    entryFees: 'Nevezési díj:',
    singles25: 'Egyéni = 25 €',
    singles40: 'Egyéni = 40 €',
    doubles20: 'Páros = 20 € / játékos',
    doubles30: 'Páros = 30 € / játékos',
    feesPayment: 'A nevezési díjat banki átutalással a torna előtt, vagy készpénzben (EUR) a szervezőnél a torna alatt kell befizetni.',
    shuttlesLabel: 'A torna hivatalos labdája:',
    shuttlesBrand: 'KAWASAKI SHUTTLECOCK TEAM 1',
    shuttlesText: 'Mérkőzésenként 2 labdát biztosítunk, a továbbiakat a résztvevők maguk biztosítják. KAWASAKI SHUTTLECOCK TEAM 1 labdák a szervezőknél vásárolhatók.',
    managersMeeting: 'Csapatvezetői értekezlet:',
    meetingU17: '2026. szeptember 24., csütörtök, 19:00, a helyszínen.',
    mainEvent: 'Főtábla',
    finals: 'Döntők',
    provisionalNote: 'ⓘ Az előzetes időpontok a nevezések számától függően változhatnak. A végleges időbeosztás (az összes mérkőzés pontos tervezett befejezésével) legkésőbb 20 nappal a torna kezdete előtt jelenik meg a honlapon.',
    seedingNote: 'A kiemelés és a sorsolás a szeptember 17-i BEC European U17 ranglista alapján történt.',
    koSystemNote: 'Az egyéni versenyszámok első szakasza csoportokban, majd egyenes kieséses (KO) rendszerben zajlik; a párosok egyenes kieséses rendszerben játszanak. Vitás esetben a főbíró döntése a végleges.',
    day25: 'szeptember 25.',
    day26: 'szeptember 26.',
    day27: 'szeptember 27.',
  },

  info: {
    heroTitle: 'Információk',
    contactsTitle: 'Kapcsolat és helyszín',
    director: 'Tornaigazgató:',
    contactPerson: 'Kapcsolattartó:',
    phoneNumber: 'Telefon:',
    email: 'Email:',
    venue: 'Helyszín:',
    transportTitle: 'Transzfer',
    transportIntro: 'A szervező térítés ellenében transzfert biztosít:',
    transportDetails: 'Utazási adatait mielőbb küldje el a sj.bedminton@gmail.com címre. A transzfer díját banki átutalással a torna előtt, vagy készpénzben (EUR) a szervezőnél a torna alatt kell befizetni.',
    transportWalking: 'Minden hivatalos szálloda sétatávolságra van a helyszíntől, ezért a csarnok és a szállodák között nincs transzfer.',
    mealsDesc: 'Az étterem a csarnok része. Az ebéd és a vacsora büféasztalos formában, változatos ételekkel – all you can eat:',
    transportBa: 'POZSONYI repülőtér = 30 € / fő / egy irány',
    transportVie: 'BÉCSI repülőtér = 40 € / fő / egy irány',
    accomTitle: 'Szállás',
    accomOrder: 'A szállás közvetlenül az online foglalási űrlapunkon keresztül rendelhető meg.',
    accomPayment: 'A szállás díját banki átutalással a torna előtt, vagy készpénzben (EUR) a szervezőnél, közvetlenül a sportcsarnokba érkezés után kell rendezni. A szobáért kell fizetni, nem személyenként.',
    breakfastIncluded: 'Reggelivel',
    doubleRoom85: 'Kétágyas szoba = 85 €/éj',
    tripleRoom100: 'Háromágyas szoba = 100 €/éj',
    fourRoom110: 'Négyágyas szoba = 110 €/éj',
    doubleRoom95: 'Kétágyas szoba = 95 €/éj',
    tripleRoom110: 'Háromágyas szoba = 110 €/éj',
    singleRoom65: 'Egyágyas szoba = 65 €/éj',
    apartment170: 'Apartman (2–4 fő) = 170 €/éj',
    apartmentMinStay: 'Minimum tartózkodás = 3 éjszaka. Reggelivel.',
    apartmentDesc: 'Az apartman tartalma: 2 külön kétágyas szoba, fürdőszoba, konyha, nappali, mosógép.',
    distVenue: 'Közvetlenül a helyszínen.',
    dist14: '1,4 km-re a helyszíntől.',
    dist19: '1,9 km-re a helyszíntől.',
    servicesTitle: 'További szolgáltatások',
    stringing: 'Húrozás:',
    stringingAvail: 'A torna teljes ideje alatt elérhető:',
    stringingOnly: 'Húrozás = 10 €',
    stringingNew: 'Húrozás + új húr = 18 €',
    meals: 'Étkezés:',
    lunch: 'Ebéd = 12 €',
    dinner: 'Vacsora = 12 €',
  },

  booking: {
    headerTitle: 'Szállásfoglalás',
    headerSub: 'Slovak Junior & Youth · Trencsén',
    step1Title: 'Válasszon tornát',
    underAge: (age) => `${age} év alatt`,
    contactTitle: 'Kapcsolattartási adatok',
    firstName: 'Keresztnév',
    lastName: 'Vezetéknév',
    phone: 'Telefon',
    email: 'Email',
    emailInvalid: 'Adjon meg érvényes e-mail címet',
    selectCountry: 'Válasszon országot',
    searchCountry: 'Ország keresése…',
    chooseHotel: 'Válasszon szállodát',
    checkingAvail: 'elérhetőség ellenőrzése…',
    availUnknown: 'Az elérhetőséget nem sikerült ellenőrizni — a megjelenített számok elavultak lehetnek.',
    unavailable: 'Betelt',
    selfCatering: 'Étkezés nélkül',
    breakfast: 'Reggelivel',
    atVenue: 'A helyszínen · 0 km',
    fromVenue14: '1,4 km a helyszíntől',
    fromVenue19: '1,9 km a helyszíntől',
    rooms: 'Szobák',
    perNight: '€ / éj',
    addRoom: 'Szoba hozzáadása',
    soldOut: 'Betelt',
    minNights3: 'Az apartmanoknál minimum 3 éjszaka a tartózkodás.',
    noRoomsLeft: 'Ebben a szállodában nincs több szabad szoba',
    onlyRoomsLeft: (n) => `Már csak ${n} szoba maradt ebben a szállodában`,
    roomsAvailable: (n, total) => `Szabad szobák: ${n} / ${total}`,
    selectedRooms: 'Kiválasztott szobák',
    remove: 'Eltávolítás',
    checkin: 'Érkezés',
    checkout: 'Távozás',
    nights: (n) => `${n} éjszaka`,
    personFirst: (i) => i === 1 ? 'Keresztnév (1. személy)' : `Keresztnév (${i}. személy, nem kötelező)`,
    personLast: (i) => i === 1 ? 'Vezetéknév (1. személy)' : `Vezetéknév (${i}. személy, nem kötelező)`,
    addAnotherRoom: 'További szoba hozzáadása',
    summaryTitle: 'Foglalás összegzése',
    tournamentLabel: 'Torna:',
    hotelLabel: 'Szálloda:',
    contactLabel: 'Kapcsolat:',
    phoneLabel: 'Telefon:',
    emailLabel: 'Email:',
    person: 'Személy',
    estimatedTotal: 'Összesen',
    paymentNote: 'Fizetés banki átutalással a torna előtt, vagy készpénzben (EUR) érkezéskor. A szobáért kell fizetni, nem személyenként.',
    overFull: (hotel) => `A(z) ${hotel} éppen betelt — lépjen vissza és válasszon másik szállodát.`,
    overSome: (n, hotel, remove) => `A(z) ${hotel} szállodában már csak ${n} szoba maradt — távolítson el ${remove} szobát, vagy válasszon másik szállodát.`,
    btnContact: 'Kapcsolati adatok',
    btnHotel: 'Szálloda kiválasztása',
    btnRoom: 'Szoba kiválasztása',
    btnGuests: 'Vendégek hozzáadása',
    btnReview: 'Összegzés és küldés',
    btnSubmit: 'Foglalás elküldése',
    btnSubmitting: 'Küldés…',
    btnBack: 'Vissza',
    btnClose: 'Bezárás',
    successTitle: 'Foglalás elküldve!',
    successText: 'Szállásigényét megkaptuk. A szervező visszaigazolja, és e-mailben elküldi a fizetési tudnivalókat.',
    confirmHotelChange: 'A szálloda módosítása törli a kiválasztott szobákat. Folytatja?',
    submitError: 'Sajnáljuk, hiba történt a foglalás elküldésekor. Kérjük, próbálja újra.',
    roomTypes: {
      'Single room': 'Egyágyas szoba',
      'Double room': 'Kétágyas szoba',
      'Triple room': 'Háromágyas szoba',
      '4-person room': 'Négyágyas szoba',
      'Apartment (2-4 persons)': 'Apartman (2–4 fő)',
    },
  },

  reg: {
    notOpen: 'A nevezés még nem nyílt meg.',
    headerTitle: 'Nevezés a tornára',
    step1Title: 'Klub és kapcsolat',
    club: 'Klub neve',
    country: 'Ország',
    managerTitle: 'Csapatvezető',
    singlesTitle: 'Nevezések — egyéni',
    doublesTitle: 'Nevezések — páros',
    addSingles: 'Egyéni játékos hozzáadása',
    addDoubles: 'Páros hozzáadása',
    noEntries: 'Még nincs nevezés — ezt a lépést kihagyhatja.',
    player1: '1. játékos',
    player2opt: '2. játékos (nem kötelező)',
    partnerNote: 'A páros nevezés egy játékossal is érvényes — a partner később is megadható.',
    discipline: 'Versenyszám',
    disciplines: {
      BS: 'Fiú egyéni',
      GS: 'Lány egyéni',
      BD: 'Fiú páros',
      GD: 'Lány páros',
      XD: 'Vegyes páros',
    },
    summaryTitle: 'Nevezés összegzése',
    clubLabel: 'Klub:',
    entriesLabel: 'Nevezések:',
    entriesCount: (n) => `${n} nevezés`,
    needOneEntry: 'Küldés előtt adjon hozzá legalább egy nevezést (egyéni vagy páros).',
    btnSingles: 'Egyéni',
    btnDoubles: 'Páros',
    btnSubmit: 'Nevezés elküldése',
    successTitle: 'Nevezés elküldve!',
    successText: 'Nevezéseit megkaptuk. A szervező e-mailben visszaigazolja a regisztrációt.',
  },
};

export default hu;
